import { useState, useEffect } from 'react'
import { eventTrackService } from 'shared/application/services/EventTrackService'
import {
  getNotificationById,
  saveAllNotifications,
  saveNotificationById,
} from 'notifications/infrastructure/notificationStorage'
import { NotificationIds } from 'notifications/domain/NotificationsIds'

const useNotificationsModal = () => {
  const getInitialValue = id => {
    const initialValue = getNotificationById(id)
    if (initialValue === undefined) return true
    return !!initialValue
  }

  const [isOpen, setIsOpen] = useState({
    deactivate: getInitialValue(
      NotificationIds.AutoRefinancingDeactiveCreation,
    ),
  })

  useEffect(() => {
    saveAllNotifications()
  }, [])

  const closeModal = id => {
    saveNotificationById(id, false)

    switch (id) {
      case NotificationIds.AutoRefinancingDeactiveCreation:
        setIsOpen({ ...isOpen, deactivate: false })
        break
    }
  }

  const goTo = (path, id) => {
    eventTrackService.track('form_button_clicked', {
      category: 'behavior',
      journey: 'discovery',
      element_name: id,
    })
    closeModal(id)
    window.location.assign(path)
  }

  return {
    isOpen,
    closeModal,
    goTo,
  }
}

export { useNotificationsModal }
